module.exports = __webpack_public_path__ + "static/media/Amru Kotb.4562303d.jpg";